import {useEffect, useState} from "react";
import {PrizeBox} from "./boxes/prize/prize.box";

interface IPrizesProps {
    prizes: string[];
    wheelSize: number;
    highlightPrizeIndex: number | null;
}

export const Prizes: React.FC<IPrizesProps> = ({prizes, wheelSize, highlightPrizeIndex}) =>  {
    const [fontSize, setFontSize] = useState<string>("1.5rem");

    useEffect(() => {
        setFontSize(`${wheelSize / 180}rem`);
    }, [wheelSize]);

    return <div className="prizes" style={{position: "absolute", width: "80%", height: "80%"}}>
        {prizes.map((prize,idx) => (
            <PrizeBox className="prize_text" key={idx} pegIndex={idx} totalPegs={prizes.length} fontSize={fontSize} highlightPrize={highlightPrizeIndex === idx} >
                <div>{prize}</div>
            </PrizeBox>
        ))}
    </div>
}